<template>
  <div class="loader">
    <div class="spinner-border" data-chromatic="ignore">
      <span class="sr-only">{{ text }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'UeSpinner',
  props: {
    text: {
      type: String,
      default: 'Loading...',
    },
  },
})
</script>

<style lang="sass" scoped>
.spinner-border
  color: var(--uePurple)
  width: 3rem
  height: 3rem
</style>
